module.exports = __webpack_public_path__ + "media/images/test-img-dd00ddf42e3a4bac894e8e9e55d90b99.jpg";